<template>
  <div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="name"
        name="name"
        label="姓名"
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
        readonly
      />
      <van-field
        v-model="phone"
        name="phone"
        label="手机号"
        placeholder="手机号"
        readonly
      />
      <van-field name="gender" label="性别">
        <template #input>
          <van-radio-group v-model="gender" direction="horizontal">
            <van-radio name="男">男</van-radio>
            <van-radio name="女">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div class="save-btn">
        <van-button round block type="danger" native-type="submit">保 存</van-button>
      </div>
    </van-form>

    <Footer />
    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  import { Form, Button, Uploader, RadioGroup, Radio,Image as VanImage } from 'vant'

  export default {
    components: {
      [Form.name]: Form,
      [Button.name]: Button,
      [Uploader.name]: Uploader,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [VanImage.name]: VanImage,
    },
    name: 'edit',
    data() {
      return {
        name: '',
        phone: '',
        gender: '',
        avatar: '',
      }
    },
    created() {
      this.getUser()
    },
    methods: {
      onSubmit(values) {
        /*
        this.$api.post('user/update', values, r=>{
          if(r.success === 1){
            this.$toast('编辑成功')
          }else{
            this.$toast('编辑失败')
          }
        })
        */
      },
      getUser() {
        this.$api.get('fw/auth/user', {id: localStorage.getItem('uid')}, r=>{
          let data = r.result
          this.name = data.name
          this.gender = data.gender
          this.phone = data.phone
          this.avatar = data.avatar
          //this.fileList[0].url = data.avatar
        })
      }
    },
  }
</script>

<style scoped>
  .save-btn{
    margin: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/users/edit.vue